import { useEffect, useState } from 'preact/hooks';
import { verifyPin, verifyBiometric, hasBiometricEnrolled, unlock } from '../lib/applock.js';
import { t } from '../lib/i18n.js';

export function LockScreen() {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);
  const [tryingBiometric, setTryingBiometric] = useState(hasBiometricEnrolled());

  useEffect(() => {
    if (!tryingBiometric) return;
    verifyBiometric().then((ok) => {
      if (ok) unlock();
      else setTryingBiometric(false); // fall back to PIN, don't loop the OS prompt
    });
    // Runs once on mount only — re-triggering on every render would spam the
    // OS biometric prompt.
  }, []);

  async function submitPin(e: Event) {
    e.preventDefault();
    if (await verifyPin(pin)) {
      unlock();
    } else {
      setError(true);
      setPin('');
    }
  }

  if (tryingBiometric) {
    return (
      <main className="lock-shell">
        <p className="lock-hint">{t('appLock.waitingBiometric')}</p>
        <button type="button" onClick={() => setTryingBiometric(false)}>
          {t('appLock.usePinInstead')}
        </button>
      </main>
    );
  }

  return (
    <main className="lock-shell">
      <form className="auth-form" onSubmit={submitPin}>
        <label>
          {t('appLock.enterPin')}
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={4}
            autoFocus
            value={pin}
            onInput={(e) => {
              setError(false);
              setPin((e.target as HTMLInputElement).value.replace(/\D/g, '').slice(0, 4));
            }}
          />
        </label>
        {error && <p className="form-error">{t('appLock.wrongPin')}</p>}
        <button type="submit" disabled={pin.length !== 4}>
          {t('appLock.unlock')}
        </button>
        {hasBiometricEnrolled() && (
          <button type="button" onClick={() => setTryingBiometric(true)}>
            {t('appLock.useBiometric')}
          </button>
        )}
      </form>
    </main>
  );
}
